import React from 'react';
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react';

import SVGRenderer from '../utils/svg/SVGRenderer';

import i18n from '../i18n';
import {
  CallFlow,
  Cdr,
  Chart,
  Clock,
  DashboardI,
  Interconnection,
  Pricing,
  Products,
  Reports,
  Settings,
  Support,
  Vipp,
  WhatsApp
} from '../utils/svg/iconSVG';

const navigationItems = [
  {
    component: CNavItem,
    name: i18n.t('menu.dashboard'),
    to: '/dashboard',
    icon: (
      <div className="nav-link__Icon">
        <DashboardI />
      </div>
    )
  },
  {
    component: CNavItem,
    name: i18n.t('menu.navigator'),
    to: '/navigator',
    icon: (
      <div className="nav-link__Icon">
        <CallFlow />
      </div>
    )
  },
  {
    component: CNavGroup,
    name: i18n.t('menu.pricing-rules'),
    to: '/pricing-rules',
    icon: (
      <div className="nav-link__Icon">
        <Pricing />
      </div>
    ),
    items: [
      {
        component: CNavGroup,
        name: i18n.t('menu.callpass'),
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: 'Hub',
            to: '/payphone/hub',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: 'Rules',
            to: '/payphone',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.fastlane'),
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: 'Hub',
            to: '/fastlane/hub',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: 'Rules',
            to: '/fastlane',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.vipp'),
        icon: (
          <div className="nav-link__Icon">
            <Vipp />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: 'Hub',
            to: '/vipp/hub',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: 'Rules',
            to: '/vipp',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.vnta'),
        icon: (
          <div className="nav-link__Icon">
            <Clock />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: 'Hub',
            to: '/vnta/hub',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: 'Rules',
            to: '/vnta',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          }
        ]
      }
    ]
  },
  {
    component: CNavGroup,
    name: 'Channels',
    icon: (
      <div className="nav-link__Icon">
        <WhatsApp />
      </div>
    ),
    items: [
      {
        component: CNavGroup,
        name: i18n.t('menu.whatsapp'),
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="WhatsApp" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: i18n.t('menu.whatsapp-dashboard'),
            to: '/whatsapp-dashboard',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: i18n.t('menu.whatsapp-reports'),
            to: '/whatsapp-reports',
            icon: (
              <div className="nav-link__Icon">
                <Reports />
              </div>
            )
          },
          {
            component: CNavItem,
            name: i18n.t('menu.whatsapp-unique-links'),
            to: '/whatsapp-links',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="FastLane" />
              </div>
            )
          }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.did'),
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: i18n.t('menu.did-dashboard'),
            to: '/did-dashboard',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            // name: i18n.t('menu.did-reports'),
            name: 'Reports DID',
            to: '/did-reports',
            icon: (
              <div className="nav-link__Icon">
                <Reports />
              </div>
            )
          }
          // {
          //   component: CNavItem,
          //   name: i18n.t('menu.did-unique-links'),
          //   to: '/did',
          //   icon: (
          //     <div className="nav-link__Icon">
          //       <SVGRenderer iconName="FastLane" />
          //     </div>
          //   )
          // }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.web-rtc'),
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: 'Hub',
            to: '/web-rtc-dashboard',
            icon: (
              <div className="nav-link__Icon">
                <Chart />
              </div>
            )
          },
          {
            component: CNavItem,
            name: i18n.t('menu.web-rtc-reports'),
            to: '/cdr-reports',
            icon: (
              <div className="nav-link__Icon">
                <Reports />
              </div>
            )
          },
          {
            component: CNavItem,
            name: i18n.t('menu.web-rtc-unique-links'),
            to: '/web-rtc',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="FastLane" />
              </div>
            )
          }
        ]
      },
      {
        component: CNavGroup,
        name: i18n.t('menu.look-up'),
        to: '/look-up',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        ),
        items: [
          {
            component: CNavItem,
            name: i18n.t('menu.look-up-records'),
            to: '/look-up',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          },
          {
            component: CNavItem,
            name: i18n.t('menu.look-up-access-logs'),
            to: '/look-up/access-logs',
            icon: (
              <div className="nav-link__Icon">
                <SVGRenderer iconName="Payphone" />
              </div>
            )
          }
        ]
      }
    ]
  },
  {
    component: CNavGroup,
    name: i18n.t('menu.invoicing'),
    to: '/invoicing',
    icon: (
      <div className="nav-link__Icon">
        <Pricing />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: i18n.t('menu.invoicing-dashboard'),
        to: '/invoicing-dashboard',
        icon: (
          <div className="nav-link__Icon">
            <Chart />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.invoices'),
        to: '/invoices',
        icon: (
          <div className="nav-link__Icon">
            <Reports />
          </div>
        )
      }
    ]
  },
  {
    component: CNavGroup,
    name: i18n.t('menu.reports'),
    to: '/reports',
    icon: (
      <div className="nav-link__Icon">
        <Reports />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: i18n.t('menu.calls'),
        to: '/calls',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.payments'),
        to: '/payments',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.revenue'),
        to: '/revenue',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.cdrs-reports'),
        to: '/cdrs-reports',
        icon: (
          <div className="nav-link__Icon">
            <Cdr />
          </div>
        )
      }
    ]
  },
  {
    component: CNavTitle,
    name: i18n.t('menu.system')
  },
  {
    component: CNavItem,
    name: i18n.t('menu.products'),
    to: '/products',
    icon: (
      <div className="nav-link__Icon">
        <Products />
      </div>
    )
  },
  {
    component: CNavGroup,
    name: i18n.t('menu.settings'),
    to: '/settings',
    icon: (
      <div className="nav-link__Icon">
        <Settings />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: 'Accounts',
        to: '/accounts-v2',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Accounts" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.roles'),
        to: '/security',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Security" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.users'),
        to: '/users',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Users" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'Region Pricing',
        to: '/region-pricing',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Dollar" />
          </div>
        )
      },

      {
        component: CNavItem,
        name: 'Twilio',
        to: '/twilio-settings',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Interconnection" />
          </div>
        )
      }
    ]
  },
  {
    component: CNavGroup,
    name: 'DID Manage',
    icon: (
      <div className="nav-link__Icon">
        <SVGRenderer iconName="Interconnection" />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: 'Inventory',
        to: '/did-manage',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'Buy (Conecta)',
        to: '/did-buy',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Interconnection" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'Region Pricing DID',
        to: '/region-pricing-did',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Dollar" />
          </div>
        )
      }
    ]
  },
  {
    component: CNavGroup,
    name: 'Cronjobs',
    to: '/cronjobs',
    icon: (
      <div className="nav-link__Icon">
        <Clock />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: 'Config Jobs',
        to: '/cronjobs/config-jobs',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'Execution Jobs',
        to: '/cronjobs/execution-jobs',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        )
      }
    ]
  },
  {
    component: CNavItem,
    name: 'Provider Call Failures',
    to: '/provider-call-failures',
    icon: (
      <div className="nav-link__Icon">
        <Reports />
      </div>
    )
  },
  {
    component: CNavGroup,
    name: i18n.t('menu.interconnection'),
    to: '/interconnection',
    icon: (
      <div className="nav-link__Icon">
        <Interconnection />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: i18n.t('menu.api'),
        to: '/api',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="API" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.voip'),
        to: '/voip',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="FastLane" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: i18n.t('menu.ivr-configuration'),
        to: '/ivr-config',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="IVR" />
          </div>
        )
      }
    ]
  },
  {
    component: CNavGroup,
    name: 'Demos',
    to: '/demos',
    icon: (
      <div className="nav-link__Icon">
        <SVGRenderer iconName="Information" />
      </div>
    ),
    items: [
      {
        component: CNavItem,
        name: 'AI Agent',
        to: '/demos/eleven-labs',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'WhatsApp',
        to: '/demos/whatsapp',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Information" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'QuickPay',
        to: '/demos/quickpay',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Pricing" />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'Ventana',
        to: '/demos/ventana',
        icon: (
          <div className="nav-link__Icon">
            <Clock />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'VIP - Outbound',
        to: '/demos/vipo',
        icon: (
          <div className="nav-link__Icon">
            <Vipp />
          </div>
        )
      },
      {
        component: CNavItem,
        name: 'WebRTC',
        to: '/demos/webrtc',
        icon: (
          <div className="nav-link__Icon">
            <SVGRenderer iconName="Payphone" />
          </div>
        )
      }
    ]
  },
  {
    component: CNavItem,
    name: i18n.t('menu.support'),
    to: '/support',
    icon: (
      <div className="nav-link__Icon">
        <Support />
      </div>
    )
  }
];

export default navigationItems;
